// src/components/CommonModal.tsx
import { Modal } from "antd";
import React from "react";

interface CommonModalProps {
  visible: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children?: React.ReactNode;
  width?: number;
}

const CommonModal: React.FC<CommonModalProps> = ({
  visible,
  onClose,
  title,
  children,
  width = 600,
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title={title}
      width={width}
      centered
    >
      {children}
    </Modal>
  );
};

export default CommonModal;
